import React, { useState, useEffect } from 'react'
import {
  Dialog, TextField, Grid, DialogActions, DialogContent, Button,
  Tabs, Tab, List, ListItem, ListItemText, ListItemSecondaryAction, IconButton, Typography,
  Select, MenuItem, FormControl, Checkbox, FormControlLabel, Tooltip,
  Box,
  InputAdornment
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux'
import AutoComplite from '../../components/Autocomplite'
import * as actions from '../../reducers/form';
import DeleteIcon from '@mui/icons-material/Delete';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import { fetchDispath } from '../../functions/fetch'
import { delWorkGant, addWorkToGant, updWorkGant, delArrowWorkToGant } from '../../api/form-gant.api'
import arrowType from './gantArrowType'
import { typeGant } from '../../enum/gant.enum'
import { addGantTree, delGantArrowIdArrow, changeGantTreeAll } from '../../reducers/gant'
import { formFacilityProject } from './gant.const'
import { getProjectGant } from '../../api/form-gant.api'
import { addDays, diffDays, formDateSelector, isValidDate, todayString } from './utils/dateHelpers';
import { oneRow } from './utils/svgConfig'
import Autocomplete from '@mui/material/Autocomplete';
import { createSelector } from 'reselect';
import { formName } from './gant.const'

const TabPanel = ({ children, value, index }) => <div>{value === index && children}</div>
function formSelector(formName, field) {
  return state => state.form?.[formName]?.values[field]
}
const today = todayString()

const selectTreeById = (state) => state.form?.[formName]?.values.byId;
const selectFlat = (state) => state.gant.flat;
const selectTreeOptionsForDropdown = createSelector(
  [selectTreeById, selectFlat],
  (byId, flat) => {
    const parentArr = flat.filter(e => !!e.color).map(e => ({
      id: e.id,
      value: e.id,
      label: `${e.pos} ${byId['id' + e.id].name}`,
      name: byId['id' + e.id].name,
      level: e.level,
      paddingLeft: (e.level - 1) * 20,
    }))
    return parentArr
  }
);

export default function GantDialog({ formDialog, formName, formWork, idProject, formMaterial, setLoad, }) {
  const autocompliteParent = useSelector(selectTreeOptionsForDropdown);
  const [numbTab, setNumbTab] = useState(0)
  const dispatch = useDispatch()

  const obj = useSelector(formSelector(formDialog, 'obj')) || oneRow
  const id = useSelector(formSelector(formDialog, 'id'))
  const open = useSelector(formSelector(formDialog, 'open')) || false
  const newRow = useSelector(formSelector(formDialog, 'newRow')) || false

  const startRaw = useSelector(formDateSelector(formName, 'start')) || todayString();
  const endRaw = useSelector(formDateSelector(formName, 'end')) || todayString();

  const [dateStart, setStart] = useState(today)
  const [dateEnd, setEnd] = useState(today)
  const [dateStartPlan, setStartPlan] = useState(today)
  const [dateEndPlan, setEndPlan] = useState(today)
  const [changeFactDate, setChangeFactDate] = useState(false)
  useEffect(() => {
    if (!open) return;
    if (newRow) {
      setEnd(today)
      setStart(today)
      setEndPlan(today)
      setStartPlan(today)
      setChangeFactDate(false)
    }
    else {
      setStart(obj.start)
      setEnd(obj.end)
      if (isValidDate(obj.startPlan)) { setStartPlan(obj.startPlan) } else { setStartPlan('') }
      if (isValidDate(obj.endPlan)) { setEndPlan(obj.endPlan) } else { setStartPlan('') }
      setChangeFactDate(true)
    }
  }, [open, newRow])
  const onClose = () => {
    setNumbTab(0)
    dispatch(actions.formChange(false, { field: 'open', name: formDialog }))
    if (newRow) {
      dispatch(actions.formArrayDelete(id, { field: 'allIds', name: formName }))
      dispatch(actions.formObjDelete({ id: id, field: 'byId', name: formName }))
    }
  }
  const workArr = useSelector(state => state.autocomplite[formWork]?.arr) || []
  const materialArr = useSelector(state => state.autocomplite[formMaterial]?.arr) || []

  const changeWork = (e) => {
    if (!e) {
      dispatch(actions.formChange({
        ...obj,
        idWork: oneRow.idWork,
        name: oneRow.name,
        idGroup: oneRow.idGroup,
        value: e,
        estNumber: '',
        idOrder: undefined,
        storageUnit: '',
      }, { field: 'obj', name: formDialog }))
      return;
    }
    dispatch(actions.formChange({
      ...obj,
      idWork: e.id,
      name: e.label,
      idGroup: e.groupId,
      value: e,
      estNumber: e.groupNumber,
      idOrder: undefined,
      storageUnit: e.storageUnit,
    }, { field: 'obj', name: formDialog }))
  }
  const changeParent = (e) => {
    dispatch(actions.formChange({
      ...obj,
      parentValue: e,
      parent: e ? e.value : null
    }, { field: 'obj', name: formDialog }))
  }
  const changeMaterial = (e) => {
    if (!e) {
      dispatch(actions.formChange({
        ...obj,
        idMaterial: oneRow.idMaterial,
        name: oneRow.name,
        idGroup: oneRow.idGroup,
        valueMaterial: e,
        estNumber: '',
        idOrder: undefined,
        storageUnit: '',
      }, { field: 'obj', name: formDialog }))
      return;
    }
    dispatch(actions.formChange({
      ...obj,
      idMaterial: e.id,
      name: e.label,
      idGroup: e.groupId,
      valueMaterial: e,
      estNumber: e.groupNumber,
      idOrder: undefined,
      storageUnit: e.storageUnit,
    }, { field: 'obj', name: formDialog }))
  }
  const changeObjValue = (field, value) => {
    dispatch(actions.formObjAdd(value, { field: 'obj', id: field, name: formDialog }))
  }
  const handleOk = () => {
    let correct = { start: startRaw, end: endRaw }
    if (dateStart < startRaw) {
      correct.start = addDays(dateStart, -2)
    }
    if (dateEnd > endRaw) {
      correct.end = addDays(dateEnd, -2)
    }
    if (obj.idAPI === '') {
      dispatch(fetchDispath({
        param: {
          id: idProject
        },
        body: {
          start: dateStart,
          end: dateEnd,
          startPlan: dateStartPlan,
          endPlan: dateEndPlan,
          idWork: obj.idWork,
          idMaterial: obj.idMaterial,
          pos: obj.pos || 0,
          idGroup: obj.idGroup,
          count: obj.count,
          textField: obj.textField,
          typeGant: obj.typeGant,
          progress: obj.progress,
          parent: obj.parent,
          color: obj.color,
          idDateEndLink: obj.idDateEndLink,
          idDateStartLink: obj.idDateStartLink,
        },
        request: addWorkToGant,
      })).then(res => {
        const duration = diffDays(obj.end, obj.start)

        dispatch(actions.formArrayDelete(id, { field: 'allIds', name: formName }))
        dispatch(actions.formObjDelete({ id: id, field: 'byId', name: formName }))

        dispatch(actions.formObjChangeObj({
          ...obj,
          id: 'id' + res.id,
          duration,
          idAPI: res.id,
          name: (obj.typeGant === 'textField' || obj.typeGant === 'parent' || obj.typeGant === 'milestone' || obj.typeGant === 'link') ? obj.textField : obj.name,
          start: dateStart,
          end: dateEnd,
          startPlan: dateStartPlan,
          endPlan: dateEndPlan,
        }, { field: 'byId', id: 'id' + res.id, name: formName }))
        if (Object.keys(correct).length > 0) {
          dispatch(actions.formChangeAsObj({ ...correct, count: diffDays(correct.start, correct.end) }, { name: formName }))
        }
        dispatch(actions.formChange(false, { field: 'open', name: formDialog }))
        dispatch(addGantTree({ parent: obj.parent || 0, id: Number(res.id), pos: Number(obj.pos) || 0, color: obj.color }))
        if (obj.typeGant === 'parent') {
          const objAdd = { value: res.id, label: obj.pos + ' ' + obj.textField }
          if (obj.parent) {
            const index = autocompliteParent.findIndex(el => el.value === obj.parent);
            const arr = [...autocompliteParent];
            arr.splice(index + 1, 0, objAdd);
            dispatch(actions.formChangeAsObj({ autocompliteParent: arr }, { name: formDialog }))
          }
          else {
            dispatch(actions.formArrayAdd(objAdd, { name: formDialog, field: 'autocompliteParent', end: true }))
          }
        }
      }).catch(err => console.log(err))
    }
    else {
      dispatch(fetchDispath({
        param: {
          id: obj.idAPI
        },
        body: {
          start: dateStart,
          end: dateEnd,
          startPlan: dateStartPlan,
          endPlan: dateEndPlan,
          idWork: obj.idWork,
          idMaterial: obj.idMaterial,
          progress: obj.progress,
          pos: obj.pos || 0,
          idGroup: obj.idGroup,
          count: obj.count,
          textField: obj.textField,
          typeGant: obj.typeGant,
          parent: obj.parent,
          color: obj.color,
          idDateEndLink: obj.idDateEndLink,
          idDateStartLink: obj.idDateStartLink,
        },
        request: updWorkGant(idProject),
      })).then(res => {
        const duration = diffDays(obj.end, obj.start)
        dispatch(actions.formObjChangeObj({
          ...obj,
          duration,
          name: (obj.typeGant === 'textField' || obj.typeGant === 'parent' || obj.typeGant === 'milestone' || obj.typeGant === 'link') ? obj.textField : obj.name,
          start: dateStart,
          end: dateEnd,
          startPlan: dateStartPlan,
          endPlan: dateEndPlan,
        }, { field: 'byId', id: id, name: formName }))
        dispatch(actions.formChangeAsObj({ ...correct, count: diffDays(correct.start, correct.end) }, { name: formName }))
        dispatch(actions.formChange(false, { field: 'open', name: formDialog }))
        dispatch(changeGantTreeAll({ parent: obj.parent || 0, id: Number(id.replace('id', '')), pos: Number(obj.pos) || 0, color: obj.color }))
        if (obj.typeGant === 'parent') {
          const objAdd = { value: obj.idAPI, label: obj.pos + ' ' + obj.textField }
          const index = autocompliteParent.findIndex(el => el.value === obj.idAPI);
          const arr = [...autocompliteParent];
          arr.splice(index, 1, objAdd);
          dispatch(actions.formChangeAsObj({ autocompliteParent: arr }, { name: formDialog }))
        }

      }).catch(err => console.log(err))
    }
  }
  const handleDelete = () => {
    if (obj.idAPI === '') {
      onClose()
      dispatch(actions.formArrayDelete(id, { field: 'allIds', name: formName }))
      dispatch(actions.formObjDelete({ id: id, field: 'byId', name: formName }))
    }
    else {
      dispatch(fetchDispath({
        param: {
          id: obj.idAPI
        },
        request: delWorkGant(idProject),
      })).then(res => {
        setLoad(true)
        // dispatch(actions.formArrayDelete(id, { field: 'allIds', name: formName }))
        // dispatch(actions.formObjDelete({ id: id, field: 'byId', name: formName }))
        onClose()
      }).catch(err => console.log(err))
    }
  }
  if (!open) return null
  const autocompleteMap = {
    work: { options: workArr, onChange: changeWork, label: 'Работа', value: obj.value },
    material: { options: materialArr, onChange: changeMaterial, label: 'Материал', value: obj.valueMaterial },
  };
  const autocompleteProps = autocompleteMap[obj.typeGant];
  const showTextField = ['textField', 'parent', 'milestone', 'link'].includes(obj.typeGant);

  return (
    <Dialog
      open={open}
      maxWidth='sm'
      keepMounted
      fullWidth
      scroll="paper"
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      PaperProps={{ style: { minHeight: 480 } }}
    >
      <DialogContent >
        <Tabs value={numbTab} onChange={(e, v) => setNumbTab(v)} indicatorColor='primary'>
          <Tab label='Основные' />
          <Tab label='Связи' disabled={newRow || obj.typeGant === 'parent'} />
        </Tabs>
        <TabPanel value={numbTab} index={0}>
          <Grid container
            direction='column'
            spacing={1}
            alignItems="flex-start"
          >
            <Grid item container direction="row" spacing={2}>
              <Grid item xs={12}>
                <Autocomplete
                  disablePortal
                  options={autocompliteParent || []}
                  onChange={(event, newValue) => { changeParent(newValue); }}
                  isOptionEqualToValue={(option, value) => option.id === value?.id}
                  filterOptions={(options, state) => {
                    const inputValue = state.inputValue.toLowerCase();
                    return options.filter(option =>
                      option.name.toLowerCase().includes(inputValue)
                    );
                  }}
                  value={obj.parent ? { ...obj.parentValue, id: obj.parent } : null}
                  renderOption={(props, option) => (
                    <li
                      {...props}
                      key={option.id}
                      style={{
                        paddingLeft: `${option.paddingLeft + 16}px`, // +16 для базового отступа MUI
                        fontWeight: option.level === 1 ? 600 : 400, // жирный для корней
                      }}
                    >
                      {option.label}
                    </li>
                  )}
                  renderInput={(params) => <TextField {...params} variant="standard" label="Родитель" />}
                />
              </Grid>
              <Grid
                item
                xs={12}
                container
                direction="row"
                justifyContent="flex-start"
                alignItems="flex-end"
                spacing={2}
              >
                <Grid item xs={3}>
                  <TextField
                    fullWidth
                    variant="standard"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    onChange={(e) => changeObjValue('pos', e.target.value)}
                    value={obj.pos || ''}
                    label='Позиция в гант'
                  />
                </Grid>
                <Grid item xs={9} >
                  <TextField
                    select
                    fullWidth
                    label="Тип"
                    variant="standard"
                    value={obj.typeGant}
                    onChange={(e) => changeObjValue('typeGant', e.target.value)}
                    sx={{ flex: 1 }}
                    disabled={obj.idAPI !== ''}
                    SelectProps={{
                      renderValue: (value) => {
                        const selected = typeGant.find(o => o.value === value);
                        if (!selected) return '';
                        return (
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                            <Box
                              sx={{
                                width: 16,
                                height: 16,
                                backgroundColor: selected.color,
                                borderRadius: 1,
                                flexShrink: 0,
                              }}
                            />
                            {selected.label}
                          </Box>
                        );
                      },
                    }}
                  >
                    {typeGant.map((option) => (
                      <MenuItem
                        key={option.value}
                        value={option.value}
                        sx={{ display: 'flex', alignItems: 'center', gap: 1 }}
                      >
                        <Box
                          sx={{
                            width: 16,
                            height: 16,
                            backgroundColor: option.color,
                            borderRadius: 1,
                            mr: 1,
                            flexShrink: 0,
                          }}
                        />
                        {option.label}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>
              </Grid>
              {autocompleteProps && (
                <Grid item xs={12}>
                  <AutocompliteAll {...autocompleteProps} />
                </Grid>
              )}

              {showTextField && (
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    variant="standard"
                    type="text"
                    InputLabelProps={{ shrink: true }}
                    onChange={(e) => changeObjValue('textField', e.target.value)}
                    value={obj.textField || ''}
                    label="Текст"
                  />
                </Grid>
              )}
              {(obj.typeGant === 'milestone') &&
                <Grid item xs={6}>
                  <TextField
                    type="date"
                    variant="standard"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    onChange={(e) => {
                      setStartPlan(e.target.value)
                      setEndPlan(e.target.value)
                      setStart(e.target.value)
                      setEnd(e.target.value)
                    }}
                    fullWidth
                    value={dateStartPlan}
                    label='Дата'
                  />
                </Grid>}
              {
                (obj.typeGant !== 'parent' && obj.typeGant !== 'milestone' && obj.typeGant !== 'link') && <React.Fragment>
                  <Grid item xs={6}>
                    <TextField
                      type="date"
                      variant="standard"
                      InputLabelProps={{
                        shrink: true,
                      }}
                      onChange={(e) => { setStartPlan(e.target.value); if (!changeFactDate) setStart(e.target.value) }}
                      fullWidth
                      value={dateStartPlan}
                      label='Начало план'
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      variant="standard"
                      type="date"
                      InputLabelProps={{
                        shrink: true,
                      }}
                      onChange={(e) => { setEndPlan(e.target.value); if (!changeFactDate) setEnd(e.target.value) }}
                      value={dateEndPlan}
                      label='Окончание план'
                      fullWidth
                      inputProps={{
                        min: dateStartPlan
                      }}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          onClick={(e) => setChangeFactDate(e.target.checked)}
                          checked={changeFactDate}
                          inputProps={{ 'aria-label': 'Факт отличается от плана' }}
                        />
                      }
                      label='Факт отличается от плана'
                    />
                  </Grid>
                  {changeFactDate && <React.Fragment>
                    <Grid item xs={6}>
                      <TextField
                        variant="standard"
                        type="date"
                        InputLabelProps={{
                          shrink: true,
                        }}
                        onChange={(e) => { setStart(e.target.value) }}
                        fullWidth
                        value={dateStart}
                        label='Начало'
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <TextField
                        variant="standard"
                        type="date"
                        InputLabelProps={{
                          shrink: true,
                        }}
                        onChange={(e) => setEnd(e.target.value)}
                        value={dateEnd}
                        label='Окончание'
                        fullWidth
                        inputProps={{
                          min: dateStart
                        }}
                      />
                    </Grid>
                  </React.Fragment>}
                  <Grid item xs={6}>
                    <TextField
                      fullWidth
                      variant="standard"
                      type="number"
                      InputLabelProps={{
                        shrink: true,
                      }}
                      onChange={(e) => changeObjValue('count', e.target.value)}
                      onFocus={e => e.target.select()}
                      value={obj.count || 0}
                      label='Количество'
                      inputProps={{
                        min: 0,
                      }}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    {obj.typeGant === 'textField' ?
                      <TextField
                        fullWidth
                        variant="standard"
                        type="number"
                        InputLabelProps={{
                          shrink: true,
                        }}
                        onChange={(e) => changeObjValue('progress', e.target.value)}
                        onFocus={e => e.target.select()}
                        value={obj.progress}
                        label='Прогресс, %'
                        inputProps={{
                          min: 0,
                          max: 100
                        }}
                      />
                      : <div>
                        <div>Прогресс:{obj.progress}%</div>
                        <div>Выполнено:{obj.perf} {obj.storageUnit}</div>
                      </div>
                    }

                  </Grid>

                </React.Fragment>
              }
              {(obj.typeGant === 'parent') &&
                <Grid item xs={3}>
                  <TextField
                    variant="standard"
                    fullWidth
                    type="color"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    onChange={(e) => { changeObjValue('color', e.target.value) }}
                    value={obj.color || '#aaaaaa'}
                    label='Цвет'
                  />
                </Grid>}
              {obj.typeGant === 'link' && <TypeLink formName={formName} formDialog={formDialog}
                setStart={e => setStart(e)}
                setEnd={e => setEnd(e)}
                setStartPlan={e => setStartPlan(e)}
                setEndPlan={e => setEndPlan(e)}
              />}
            </Grid>
          </Grid>
        </TabPanel>
        <TabPanel value={numbTab} index={1}>
          <TabDependencies formName={formName} obj={obj} formDialog={formDialog} idProject={idProject} />
        </TabPanel>
      </DialogContent>
      <DialogActions>
        <Grid container direction='row' alignItems="flex-end">
          <Grid item xs={3}>
            <Button
              variant="contained"
              color="primary"
              startIcon={<CheckIcon />}
              onClick={handleOk}
              size='small'
            >Сохранить
            </Button>
          </Grid>
          <Grid item xs={3}>
            <Button
              variant="contained"
              color="primary"
              startIcon={<CloseIcon />}
              onClick={onClose}
              size='small'
            >Отменить
            </Button>
          </Grid>
          <Grid item container direction='row' justifyContent="flex-end" alignItems="flex-end" xs={6}>
            <Grid item>
              <Button
                variant="contained"
                color="secondary"
                startIcon={<DeleteIcon />}
                onClick={handleDelete}
                size='small'
              >Удалить
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </DialogActions>
    </Dialog>
  );
}

function AutocompliteAll({ options, onChange, label, value }) {
  return <Autocomplete
    disablePortal={false}
    options={options}
    onChange={(event, newValue) => { onChange(newValue); }}
    isOptionEqualToValue={(option, value) => option.id === value?.id}
    groupBy={(option) => option.groupName}
    getOptionLabel={(option) => option.label}
    renderInput={(params) => (
      <Tooltip
        title={value?.label || ''}
        placement="top"
        arrow
        disableHoverListener={!value}
      >
        <TextField
          {...params}
          label={label}
          placeholder="Начните вводить..."
          variant="standard"
          fullWidth
        />
      </Tooltip>
    )}
    value={value}
    sx={{
      // Стили заголовков групп
      '& .MuiAutocomplete-groupHeader': {
        backgroundColor: '#f5f5f5',
        fontWeight: 600,
        fontSize: '0.8rem',
        color: '#555',
        padding: '8px 16px',
        position: 'sticky',
        top: 0,
        zIndex: 1,
        borderBottom: '1px solid #e0e0e0',
      },
      // Стили опций
      '& .MuiAutocomplete-option': {
        minHeight: '40px',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
      },
      // Стили выбранного значения
      '& .MuiAutocomplete-inputRoot': {
        fontSize: '0.9rem',
      },
    }}
  />
}

function TabDependencies({ formName, obj, formDialog, idProject }) {
  const formAll = useSelector(state => state.form[formName] || state.form.default)
  const dispatch = useDispatch()
  const handleDeleteArrow = (id) => {
    dispatch(fetchDispath({
      param: {
        idWork: obj.idAPI,
        idArrow: id
      },
      request: delArrowWorkToGant(idProject),
    })).then(res => {
      const dependencies = obj.dependencies.filter(e => e.id !== id)
      dispatch(actions.formObjChangeObj({ dependencies }, { field: 'byId', id: obj.id, name: formName }))
      dispatch(actions.formChange({
        ...obj,
        dependencies
      }, { field: 'obj', name: formDialog }))
      dispatch(delGantArrowIdArrow(id))
    }).catch(err => console.log(err))
  }
  return (
    <List>
      {obj.dependencies.filter(e => !e.parent).map((e, i) => {
        const to = formAll.values.byId[e.to]
        return (
          <ListItem key={i}>
            <ListItemText
              primary={to.name}
              secondary={arrowType.obj[e.type]}
            />
            <ListItemSecondaryAction>
              <IconButton
                edge="end"
                aria-label="delete"
                onClick={() => handleDeleteArrow(e.id)}
                size="large">
                <DeleteIcon />
              </IconButton>
            </ListItemSecondaryAction>
          </ListItem>
        );
      })}
    </List>
  );
};



function TypeLink({ formName, formDialog, setStart, setEnd, setStartPlan, setEndPlan }) {
  const projectArr = useSelector(state => state.autocomplite?.[formFacilityProject].arr || [])
  const [arrGant, setArrGant] = useState([])

  const idProjectLink = useSelector(state => state.form?.[formDialog]?.values?.obj.idProjectLink) || 0
  const valueProject = projectArr.find(e => e.value === idProjectLink) ?? null;

  const idDateEndLink = useSelector(state => state.form?.[formDialog]?.values?.obj.idDateEndLink) || 0
  const valueEnd = arrGant.find(e => e.value === idDateEndLink) ?? null;

  const idDateStartLink = useSelector(state => state.form?.[formDialog]?.values?.obj.idDateStartLink) || 0
  const valueStart = arrGant.find(e => e.value === idDateStartLink) ?? null;

  const dispatch = useDispatch()

  useEffect(() => {
    if (idProjectLink === 0) return;
    dispatch(fetchDispath({
      param: {
        id: idProjectLink
      },
      progress: true,
      request: getProjectGant,
    })).then(res => {
      const arr = res.get.filter(s => s.typeGant !== 'parent').map(e => ({ value: e.id, label: e.name, start: e.start, end: e.end, startPlan: e.startPlan, endPlan: e.endPlan }));
      setArrGant(arr)
    })
  }, [dispatch, idProjectLink])
  const handleChange = (event, newValue) => {
    dispatch(actions.formObjAdd(newValue?.value || 0, { field: 'obj', id: 'idProjectLink', name: formDialog }))
  }
  const handleChangeDateStart = (event, newValue) => {
    if (newValue) {
      dispatch(actions.formObjAdd(newValue.value, { field: 'obj', id: 'idDateStartLink', name: formDialog }))
      setStart(newValue.start)
      setStartPlan(newValue.startPlan)
      return;
    }
    dispatch(actions.formObjAdd(oneRow.idDateStartLink, { field: 'obj', id: 'idDateStartLink', name: formDialog }))
    setStart(oneRow.start)
    setStartPlan(oneRow.startPlan)
  }
  const handleChangeDateEnd = (event, newValue) => {
    if (newValue) {
      dispatch(actions.formObjAdd(newValue.value, { field: 'obj', id: 'idDateEndLink', name: formDialog }))
      setEnd(newValue.end)
      setEndPlan(newValue.endPlan)
      return;
    }
    dispatch(actions.formObjAdd(oneRow.idDateEndLink, { field: 'obj', id: 'idDateEndLink', name: formDialog }))
    setEnd(oneRow.end)
    setEndPlan(oneRow.endPlan)
  }
  return <React.Fragment>
    <Grid item xs={12}>
      <Autocomplete
        disablePortal={false}
        options={projectArr}
        onChange={handleChange}
        isOptionEqualToValue={(option, val) => {
          if (!option || !val) return false;
          return option.value === val.value;
        }}
        value={valueProject}
        renderInput={(params) => <TextField {...params} variant="standard" label="Проект" />}
      />
    </Grid>
    <Grid item xs={12}>
      <Autocomplete
        disablePortal={false}
        options={arrGant}
        onChange={handleChangeDateStart}
        isOptionEqualToValue={(option, val) => {
          if (!option || !val) return false;
          return option.value === val.value;
        }}
        getOptionLabel={(option) => option.label} // это для отображения, не для ключа
        renderOption={(props, option) => (
          <li {...props} key={option.value}> 
            {option.label}
          </li>
        )}
        value={valueStart}
        renderInput={(params) => <TextField {...params} variant="standard" label="Начальная задача" />}
      />
    </Grid>
    <Grid item xs={12}>
      <Autocomplete
        disablePortal={false}
        options={arrGant}
        onChange={handleChangeDateEnd}
        isOptionEqualToValue={(option, val) => {
          if (!option || !val) return false;
          return option.value === val.value;
        }}
        getOptionLabel={(option) => option.label} // это для отображения, не для ключа
        renderOption={(props, option) => (
          <li {...props} key={option.value}> 
            {option.label}
          </li>
        )}
        value={valueEnd}
        renderInput={(params) => <TextField {...params} variant="standard" label="Окончательная задача" />}
      />
    </Grid>
    <Grid item xs={12}><Typography>{`план: с ${dateFormat(valueStart?.start)} по ${dateFormat(valueEnd?.end)}`}</Typography></Grid>
    <Grid item xs={12}><Typography>{`факт: с ${dateFormat(valueStart?.startPlan)} по ${dateFormat(valueEnd?.endPlan)}`}</Typography></Grid>
  </React.Fragment>
}

function dateFormat(date) {
  return date?.split('-').reverse().join('.') ||''
}